import {
  createDashboardStore,
  createMergeDashboardState,
  formatInt,
  formatIsoDate,
  formatPct,
  localeForLanguage,
  type DashboardBoardState,
  type DashboardNumberMode,
} from "../../../shared/dashboard/dashboardStore"

export { formatInt, formatIsoDate, formatPct, localeForLanguage }
export type { DashboardNumberMode }

export type DashboardWidgetKey =
  | "coverage"
  | "frameworks"
  | "waiting"
  | "open"
  | "conformity"
  | "gaps"

export const DEFAULT_WIDGET_ORDER: DashboardWidgetKey[] = [
  "coverage",
  "frameworks",
  "waiting",
  "open",
  "conformity",
  "gaps",
]

export type CustomerDashboardState = DashboardBoardState<DashboardWidgetKey>

export const useCustomerDashboardStore =
  createDashboardStore<DashboardWidgetKey>({
    persistKey: "mc-customer-dashboard",
    defaultOrder: DEFAULT_WIDGET_ORDER,
  })

/**
 * Standalone merge fn re-exported for direct unit testing — bound to this
 * studio's DEFAULT_WIDGET_ORDER, mirrors the supplier store's shape.
 */
export const mergeDashboardState =
  createMergeDashboardState(DEFAULT_WIDGET_ORDER)
